import React, {useState,useEffect} from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup'
import {Tab, Row, Col, Button, Card, Accordion} from 'react-bootstrap';
import {FormControl, Spinner} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import be from '../../../BE';
import auth from '../../../Account/Auth';

function AgencyName({loading, agency, setAgency}){
  const [processing,setProcessing] = useState(false);
  const [status,setStatus] = useState(0);

  async function setAgencyDescription(e) {
    e.preventDefault();
    setProcessing(true);
    setStatus(0);
    await auth.isAuthenticated()
      .then(async () => {
        await be.post("agency","/agency/settings/description",{agencyDescription : agency?.description},true,true,true)
          .then((r) => setStatus(200))
          .catch((e) => {setStatus(e?.response?.status)})
      })
      .catch(error => console.log(error))
    setProcessing(false);
  }

  const handleChange = (e) => {
    setStatus(0);
    let inputText = e.target.value;
    let name = e.target.name;
    setAgency({...agency , [name] : inputText});
  }

  return(
    <>
      <h4>Description</h4>
      <span>set here the description of your agency</span>
      <Form onSubmit={setAgencyDescription}>
        <InputGroup>
          <FormControl
            type="text"
            name="description"
            id="agency-description-field"
            aria-describedby="agency description"
            value={loading ? "Loading..." : agency?.description}
            disabled={loading}
            onChange={handleChange}
          />
          <Button disabled={loading || processing} type='submit'>
            {processing 
              ? 
                <Spinner size="sm" animation="border" variant="light" /> 
                : 
                <i className="fas fa-long-arrow-alt-right"></i>
            }
          </Button>
        </InputGroup>
      </Form>
      {(status >= 400 && status <= 500) &&
      <p className="text-danger"><small>error</small></p>
      }
      {status === 200 &&
        <p className="text-success"><small>success</small></p>
      }
    </>
  );
}

export default AgencyName
